import React from 'react';
import T from 'prop-types';
import { notification } from 'antd';

class Notification extends React.PureComponent {
  componentDidUpdate() {
    const { notificationOptions, type } = this.props;

    notification[type](notificationOptions);
  }

  render() {
    return null;
  }
}

Notification.propTypes = {
  notificationOptions: T.object.isRequired,
  type: T.string.isRequired,
};

export default Notification;
